<template>
  <transition name="sticky" @after-enter="slideInContent">
    <div class="sticky-contact" v-if="showSticky" @click="openCallMe">
      <div class="sticky-contact__inner">
        <transition name="contentbox">
          <div
            class="sticky-contact__content"
            :class="showContent ? 'show-content' : ''"
          >
            <div
              class="sticky-contact__text"
              :class="showText ? 'show-text' : ''"
            >
              <div class="sticky-contact__text-label" v-if="lang == 'da'">
                Har du brug for hjælp?
              </div>
              <div class="sticky-contact__text-label" v-else>
                Do you need help?
              </div>
              <div class="sticky-contact__text-name" v-if="lang == 'da'">
                Bliv ringet op
              </div>
              <div class="sticky-contact__text-name" v-else>
                Let us call you
              </div>
            </div>
          </div>
        </transition>
        <div class="sticky-contact__box">
          <div class="sticky-contact__icon">
            <img src="../../../../_img/phone.svg" alt="Letter icon" />
            <!-- <PhoneIcon class="test"></PhoneIcon> -->
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import PhoneIcon from "../../../../_img/phone.svg";

export default {
  name: "StickyContact",
  components: {},
  props: {
    title: String,
    text: String,
    lang: {
      Type: String,
    },
  },
  data: () => ({
    show: false,
    showContent: false,
    showText: false,
    lastScrollTop: 0,
  }),
  computed: {
    showSticky() {
      if (this.show && !this.hide) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    openCallMe: function() {
      this.$emit("open");
    },
    slideInContent() {
      if (window.innerWidth > 767) {
        this.showContent = true;
        setTimeout(() => {
          this.showText = true;
        }, 300);
      }
    },
    onScroll() {
      if (window.innerWidth > 767) {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > this.lastScrollTop) {
          this.showText = false;
          this.showContent = false;
        } else {
          this.slideInContent();
        }
        this.lastScrollTop = st <= 0 ? 0 : st;
      }
    },
  },
  mounted() {
    this.show = true;
    window.addEventListener("scroll", this.onScroll);
  },
};
</script>

<style lang="scss">
@import "../../../../_scss/_vars.scss";
@import "../../../../_scss/utils/utils.scss";

.sticky-contact {
  background-color: #fff;
  border-radius: 10px;
  border: 5px solid #fff;
  bottom: 20px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.12);
  cursor: pointer;
  display: flex;
  overflow: hidden;
  flex-flow: row wrap;
  justify-content: space-evenly;
  position: fixed;
  right: 20px;
  z-index: 999;
  transition: all $t-hover;

  &:hover {
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    .sticky-contact__box {
      &::after {
        opacity: 1;
      }
    }
  }

  &__inner {
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    height: 50px;
    width: 100%;
  }

  &__content {
    align-items: center;
    display: flex;
    flex-flow: row wrap;
    height: 50px;
    position: relative;
    max-width: 50px;
    transition: max-width 800ms $t-nice;
  }

  &__text {
    color: #000000;
    font-size: 14px;
    letter-spacing: -0.11px;
    line-height: 1.3;
    padding-left: 20px;
    padding-right: 82px;
    opacity: 0;
    transition: opacity 400ms $t-nice;

    &-label {
      font-weight: 700;
    }

    &-name {
      opacity: 0.5;
    }
  }

  &__box {
    align-items: center;
    display: flex;
    height: 50px;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    transition: transform 400ms $t-nice, background $t-hover;
    width: 50px;
    z-index: 110;
    background: $c-primary;
    border-radius: 6px;
    overflow: hidden;

    &:before,
    &::after {
      display: block;
      content: "";
      position: absolute;
      z-index: -1;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transition: all $t-hover;
      pointer-events: none;
    }

    &::before {
      background-image: linear-gradient(
        180deg,
        $c-primary 0%,
        lighten($c-primary, 30) 100%
      );
      opacity: 1;
    }

    &::after {
      background-image: linear-gradient(
        180deg,
        $c-primary 0%,
        lighten($c-primary, 30) 100%
      );
      opacity: 0;
    }
  }

  &__icon {
    line-height: 0;
    img {
      width: 20px;
    }
  }
}

@media all and (max-width: 767px) {
  .sticky-contact {
    bottom: 10px;
    right: 10px;
  }
}

// Transitions
.sticky-enter-active {
  animation: sticky-coming 1s;
  transition: $t-nice;
}

@keyframes sticky-coming {
  0% {
    opacity: 0;
    width: 70px;
  }

  40% {
    opacity: 0;
    width: 70px;
  }

  100% {
    opacity: 1;
    width: 70px;
  }
}

.sticky-contact {
  &__content {
    &.show-content {
      max-width: 600px;
    }
  }

  .show-text {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// assets/_js/components/CtaContainer/StickyContact/StickyContact.vue